import React from "react";
import { Reveal, Eyebrow } from "./ui";
import { heroMockup } from "./data";
const markers = ["6 guías", "+500 páginas", "3 recursos extra", "Acceso inmediato"];

/** Hero-like product moment: the collection as one premium object. */
export function ProductShowcase() {
  return <section id="coleccion" className="relative w-full overflow-hidden bg-[var(--ink)] px-4 py-12 sm:px-8 sm:py-20" data-id="element-199" data-mp="2xmi4zcker9ou">
      <div className="pointer-events-none absolute -left-24 top-10 h-64 w-64 rounded-full bg-[#2d74e8]/30 blur-3xl" data-id="element-200" data-mp="29vuj1ndnqjja" />
      <div className="pointer-events-none absolute -right-20 bottom-0 h-64 w-64 rounded-full bg-[#59ad7a]/20 blur-3xl" data-id="element-201" data-mp="24yunw7icj16y" />

      <div className="relative mx-auto max-w-5xl text-center" data-id="element-202" data-mp="2jw4ylen6031m">
        <Reveal data-id="element-203" data-mp="2evh4gk3n3636">
          <Eyebrow tone="light" data-id="element-204" data-mp="2euxlr1660do3">El sistema completo</Eyebrow>
          <h2 className="font-serif-display text-[1.8rem] font-semibold leading-[1.08] tracking-[-0.02em] text-white sm:text-[2.6rem]" data-id="element-205" data-mp="3v9h55xab6zrh">
            Pequeños Pasos, Grandes Logros™
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/75 sm:text-base" data-id="element-206" data-mp="24aflyk099zqz">
            6 guías digitales organizadas para comprender mejor diferentes situaciones y sumar
            herramientas para acompañar el día a día.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-207" data-mp="2e6ir7yqemei5">
          <img src={heroMockup} alt="Colección completa Pequeños Pasos, Grandes Logros" className="mx-auto mt-7 w-full max-w-[300px] rounded-[1.5rem] border-4 border-white/90 object-contain shadow-[0_34px_60px_-26px_rgba(0,0,0,0.85)] sm:mt-10 sm:max-w-[520px] sm:border-[6px]" loading="lazy" data-id="element-208" data-mp="2iagnm1ochb7i" />
        </Reveal>

        <Reveal delay={0.15} data-id="element-209" data-mp="1uijbsakwaj6e">
          <ul className="mx-auto mt-7 grid max-w-2xl grid-cols-2 gap-2 sm:mt-9 sm:grid-cols-4 sm:gap-3" data-id="element-210" data-mp="1zbm5qjtl3un4">
            {markers.map(m => <li key={m} className="rounded-xl bg-white/10 px-2 py-2.5 text-[11px] font-bold uppercase tracking-[0.06em] text-white sm:rounded-2xl sm:py-3 sm:text-xs" data-id="element-211" data-mp="12sy3vd40nsbt">
                {m}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}